import {
    faHeartbeat, faBuilding, faUsersCog, faSitemap, faToggleOn, faCogs, faDatabase, faSearch,
} from '@fortawesome/free-solid-svg-icons';

export const SUPER_ADMIN_NAV = [
    { to: '/super-admin', label: 'Platform Health', icon: faHeartbeat, end: true },
    { to: '/super-admin/tenants', label: 'Tenant & Org Management', icon: faBuilding },
    { to: '/super-admin/users', label: 'User & Grant Administration', icon: faUsersCog },
    { to: '/super-admin/roles', label: 'Role & Permission Matrix', icon: faSitemap },
    { to: '/super-admin/flags', label: 'Feature Flags & Rollouts', icon: faToggleOn },
    { to: '/super-admin/config', label: 'System Configuration', icon: faCogs },
    { to: '/super-admin/data-ops', label: 'Data Ops', icon: faDatabase },
    { to: '/super-admin/audit', label: 'Global Audit Search', icon: faSearch },
];
